import { configureStore } from '@reduxjs/toolkit'
import loginSlice from './authSlice'
import userSlice from './userSlice'

export default configureStore({
  reducer: {
    loginSlice: loginSlice.reducer,
    userSlice: userSlice.reducer,
  },
})